import React from 'react';
import './index.less';

const Mask = props => {
    // eslint-disable-next-line
    const {children} = props;
    return (
        <div className="mask-wrapper">
            {children}
        </div>
    );
};

export default Mask;
